import { Head, Link, router } from '@inertiajs/react'
import { Anchor, Button, Group, Paper, PinInput, Stack, Text, Title } from '@mantine/core'
import { IconMailFilled } from '@tabler/icons-react'
import { useState } from 'react'

export default function ConnectionCodeSentPage({ email }: { email: string | null }) {
  const [code, setCode] = useState('')
  const [isPending, setIsPending] = useState(false)

  const submitCode = (value: string) => {
    if (!email || isPending) return
    setIsPending(true)
    router.post(
      '/session',
      { email, code: value },
      {
        onFinish: () => {
          setIsPending(false)
          setCode('')
        },
      }
    )
  }

  const handleSubmit = () => submitCode(code)

  return (
    <>
      <Head title="Vérifiez votre email | Seamflow" />
      <div
        style={{
          padding: 'var(--mantine-spacing-xl)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '50vh',
        }}
      >
        <Stack align="center" gap="lg" style={{ width: '100%', maxWidth: '500px' }}>
          <Group gap="sm" justify="center">
            <Title order={2} className="flex items-center gap-2">
              <IconMailFilled size={28} />
              Vérifiez votre email
            </Title>
          </Group>

          <Paper shadow="sm" p="xl" radius="md" withBorder style={{ width: '100%' }}>
            <Stack gap="md" align="center">
              <Text size="lg" fw={500}>
                Nous vous avons envoyé un code de connexion!
              </Text>
              <Text c="dimmed" ta="center">
                Saisissez le code reçu par email pour vous connecter. Il expirera dans 5 minutes.
              </Text>

              {email && (
                <Stack gap="md" align="center">
                  <PinInput
                    length={6}
                    type="number"
                    inputMode="numeric"
                    oneTimeCode
                    autoFocus
                    value={code}
                    onChange={setCode}
                    onComplete={submitCode}
                    disabled={isPending}
                    aria-label="Code de connexion"
                  />
                  <Button onClick={handleSubmit} loading={isPending} disabled={code.length < 6} radius="md">
                    Se connecter
                  </Button>
                </Stack>
              )}
            </Stack>
          </Paper>

          <Text size="sm" c="dimmed" ta="center">
            Vous n'avez pas reçu l'email? Vérifiez votre dossier spam ou{' '}
            <Anchor component={Link} href="/session/new">
              réessayez
            </Anchor>
          </Text>
        </Stack>
      </div>
    </>
  )
}
